import * as React from 'react';
export const dinersSvg = React.forwardRef(function dinersSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M9.983 1.986C13.093 2.216 15.5 4.84 15.5 8s-2.407 5.783-5.517 6.014v.017H6.017v-.017C2.907 13.784.5 11.16.5 8s2.407-5.784 5.517-6.014V1.97h3.966v.016Zm-3.533.789c-2.848 0-5.157 2.34-5.157 5.225 0 2.886 2.31 5.227 5.157 5.227 2.849 0 5.158-2.34 5.158-5.227 0-2.886-2.31-5.225-5.158-5.225Zm-1.19 8.634A3.616 3.616 0 0 1 2.887 8c0-1.53.951-2.896 2.375-3.409v6.818Zm2.38-6.818a3.616 3.616 0 0 1 2.376 3.41A3.616 3.616 0 0 1 7.64 11.41V4.59Z',
    }),
  );
});
dinersSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var diners = {
  category: 'paymentmethod',
  colorable: true,
  name: 'diners',
  svg: dinersSvg,
};
